import 'css-chunksrc/client/scenes/assistantShortcut/styles.scss';export default {
  "assistantShortcut": "_assistantShortcut_19wxh_1",
  "icon": "_icon_19wxh_6"
};